import { render } from "./InstructorCourses.vue?vue&type=template&id=c4f56c2c&scoped=true"
import script from "./InstructorCourses.vue?vue&type=script&lang=js"
export * from "./InstructorCourses.vue?vue&type=script&lang=js"

import "./InstructorCourses.vue?vue&type=style&index=0&id=c4f56c2c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4f56c2c"]])

export default __exports__